import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SwitchWithLabel } from '../../../components/form/Switch'
import { useLinkTreeFormActions } from './_form/LinkTreeFormHandler'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import LinkTreeItemActions from './LinkTreeItemActions'
import Panel from '../../../components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import LinkTreeItemSection from './sections/LinktreeItemSection'

const LinkTreeItemPanel = ({ item, isLast, isTheOnlyOne, index }) => {
  const { t } = useTranslation('editLinkTreeItems')
  const { handleChange } = useLinkTreeFormActions()

  React.useEffect(() => {
    if (!isTheOnlyOne) handleChange(index, 'isDefault', false)
  }, [isTheOnlyOne, handleChange, index])

  return (
    <Panel
      lineBorder
      mediumPadding
      noMargin
      opacity={!item.enabled && '.9'}
      bgColor={!item.enabled && COLORS.dark5 + '65'}
      key={index}
    >
      <Separator weight={1} />
      <FlexGrid gutter={1} justify="space-between">
        <FlexCol flex={0}>
          <SwitchWithLabel
            size="small"
            noMargin
            label={item.enabled ? t('enabled') : t('disabled')}
            value={item.enabled}
            onChange={() => handleChange(index, 'enabled', !item.enabled)}
          />
        </FlexCol>

        <FlexCol>
          <SwitchWithLabel
            size="small"
            noMargin
            label={t('autoRedirect')}
            value={item.isDefault}
            onChange={() => handleChange(index, 'isDefault', !item.isDefault)}
            disabled={!isTheOnlyOne || !item.enabled}
            noWrap
          />
        </FlexCol>

        <FlexCol>
          <SwitchWithLabel
            size="small"
            noMargin
            label={t('isHistory')}
            value={item?.configuration?.isPublicHistory}
            onChange={() => {
              handleChange(index, 'url', window.location.host)
              handleChange(index, 'label', undefined)

              return handleChange(index, 'configuration', {
                ...(item?.configuration ?? {}),
                isPublicHistory: !item?.configuration?.isPublicHistory
              })
            }}
            noWrap
          />
        </FlexCol>

        <FlexCol flex={1} />
        <FlexCol flex={0}>
          <LinkTreeItemActions index={index} item={item} isLast={isLast} />
        </FlexCol>
      </FlexGrid>

      <Separator weight={3} />

      <LinkTreeItemSection item={item} index={index} isLast={isLast} isTheOnlyOne={isTheOnlyOne} />
    </Panel>
  )
}

export default LinkTreeItemPanel
